import * as Dialog from "../framework/dialog";
import { getUITranslation } from "../utils/get_ui_translation";

document.addEventListener("DOMContentLoaded", function () {
  if ($(".js-training-session-public").length > 0) {
    setTimeout(checkIfActivity, 500);
  }
});

async function checkIfActivity() {
  if ($(".pending-evaluation[data-type=activity]").length > 0) {
    const success = await Dialog.yesNo(
      getUITranslation("Rejoindre le quiz démarré !"),
      getUITranslation("L'intervenant vous attend dans une activité interactive, rejoignez le en cliquant sur Oui")
    );
    if (success) {
      window.location.href = $(".pending-evaluation[data-type=activity] a").prop("href");
    }
  }
}
